import { fixInternalLinks, stripTrailingHrs } from "@/utils/contentHelpers";

export default function CypherpunkTrackerBody({ body }: { body: string }): React.ReactElement {
  const html = stripTrailingHrs(fixInternalLinks(body));

  return (
    <section className="info-section">
      <div className="info-section__prose" dangerouslySetInnerHTML={{ __html: html }} />
    </section>
  );
}
